import { company, profileBase } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getCompanyList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(company.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCompanyObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${company.base}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCompanyStatistics(id, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${company.base}${id}/statistics/`, { params: params, })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createCompanyObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${company.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateCompanyObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${company.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateCompanyObject(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${company.base}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCompanySelectList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(company.select, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateCompanyConfiguration(companyId, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${profileBase}change_company_details/?company=${companyId}`,
          payload
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  renewSubscription(companyId, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${company.base}${companyId}/add_new_subscription/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  checkSubscriptionLimit(companyId, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${company.base}${companyId}/check_subscription_limit/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
